// GraphQL queries for the application
import { gql } from "@apollo/client";

// Transcript-related queries
export const GET_TRANSCRIPT_SEGMENTS = gql`
  query GetTranscriptSegments($meetingId: String, $sessionId: ID) {
    getTranscriptSegments(meetingId: $meetingId, sessionId: $sessionId) {
      id
      sessionId
      meetingId
      segmentId
      speaker
      text
      timestamp
      audioStart
      audioEnd
      confidence
      createdAt
    }
  }
`;

export const GET_TRANSCRIPT_TIME_RANGE = gql`
  query GetTranscriptTimeRange(
    $meetingId: String!
    $startTime: Float!
    $endTime: Float!
  ) {
    getTranscriptTimeRange(
      meetingId: $meetingId
      startTime: $startTime
      endTime: $endTime
    ) {
      id
      sessionId
      meetingId
      segmentId
      speaker
      text
      timestamp
      audioStart
      audioEnd
      confidence
      createdAt
    }
  }
`;

export const GET_TRANSCRIPT_TEXT = gql`
  query GetTranscriptText($meetingId: String, $sessionId: ID) {
    getTranscriptText(meetingId: $meetingId, sessionId: $sessionId) {
      meetingId
      sessionId
      text
      segmentCount
      totalDuration
    }
  }
`;

export const GET_TRANSCRIPT_STATS = gql`
  query GetTranscriptStats($meetingId: String, $sessionId: ID) {
    getTranscriptStats(meetingId: $meetingId, sessionId: $sessionId) {
      totalSegments
      totalDuration
      speakers {
        name
        segmentCount
        duration
        wordCount
        percentage
      }
      averageConfidence
      wordCount
    }
  }
`;

// Transcript subscription
export const TRANSCRIPT_UPDATED_SUBSCRIPTION = gql`
  subscription TranscriptUpdated($meetingId: String, $sessionId: ID) {
    transcriptUpdated(meetingId: $meetingId, sessionId: $sessionId) {
      type
      segment {
        id
        sessionId
        meetingId
        segmentId
        speaker
        text
        timestamp
        audioStart
        audioEnd
        confidence
        createdAt
      }
      meetingId
      sessionId
    }
  }
`;

// Booking-related queries
export const GET_BOOKING_BY_ID = gql`
  query GetBookingById($id: ID!) {
    getBooking(id: $id) {
      id
      date
      timeStart
      timeEnd
      name
      email
      notes
      timezone
      eventTypeId
      status
      createdAt
      updatedAt
      externalMeetingId
      meetingInfo {
        link
        roomName
        attendeeName
        hostName
        provider
        createdAt
      }
    }
  }
`;

export const GET_BOOKINGS_BY_SPACE = gql`
  query GetBookingsBySpace($spaceId: ID) {
    getBookingsBySpace(spaceId: $spaceId) {
      id
      date
      timeStart
      timeEnd
      name
      email
      notes
      timezone
      eventTypeId
      status
      createdAt
      updatedAt
      externalMeetingId
      eventType {
        id
        title
        name
        description
        duration
      }
      meetingInfo {
        link
        roomName
        attendeeName
        hostName
        provider
        createdAt
      }
    }
  }
`;
